import { faHeadset } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ErrorScreen } from 'components/error-screen/ErrorScreen';
import { GradientCanvas } from 'components/gradient-canvas/GradientCanvas';
import { HomeButton } from 'components/home-button/HomeButton';

const ErrorScreen404 = () => {
  return (
    <>
      <GradientCanvas />
      <ErrorScreen>
        <div
          className={`container mb-8 max-w-[822px] text-center text-3xl font-semibold md:text-5xl`}
        >
          The page you&apos;re looking for isn&apos;t here.{' '}
          <span className={`text-butter`}>Butter luck next time!</span>
        </div>
        <div>
          <HomeButton />
          <a
            href={`${import.meta.env.VITE_GLOBAL_APP_URL}/contact`}
            className={`mb-4 block w-full rounded-md border border-gray-300 bg-gray-50 px-[18px] py-[10px] text-center text-lg font-semibold shadow md:inline-block md:w-fit`}
          >
            <FontAwesomeIcon icon={faHeadset} />
            &nbsp;Talk to Support
          </a>
        </div>
      </ErrorScreen>
    </>
  );
};

export { ErrorScreen404 };
